import Layout from "../Partials/Layout";
import {Spinner} from "react-bootstrap";
import {useEffect, useState} from "react";
import api from '../../shared/utils/auth/Index';
import {useAlert} from "react-alert";
import Loader from "../../shared/components/Loader";
import {redirect} from "../../shared/utils/helpers";
import {useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretLeft, faPlusSquare, faTimes} from "@fortawesome/free-solid-svg-icons";
import Attributes from "./Partials/Attributes";

const Form = () => {
    let {id} = useParams();

    const isItUpdate = () => {
        return id !== undefined;
    }

    let reactAlert = useAlert(null);

    const [formData, setFormData] = useState({attributes: []});

    const [sending, setSending] = useState(false);
    const onSubmit = (e) => {
        e.preventDefault();

        setSending(true);
        submit();
    }

    const submit = () => {
        let url = isItUpdate() ? `/categories/${id}` : '/categories';
        api.post(url,
            {...formData, attributes: JSON.stringify(formData.attributes)}, (res) => {

            reactAlert.success('اطلاعات ذخیره شد.')
            setSending(false);
            redirect('/categories');
        }, (err) => {
            alert('error')
            setSending(false);
        });
    }

    const onChangeImage = (e) => {
        let input = e.target;
        if (input.files && input.files[0]) {
            let reader = new FileReader();

            reader.onload = function (e2) {
                // e2.target.result
                setFormData({...formData, image: e2.target.result});
            };

            reader.readAsDataURL(input.files[0]);
        }
    }


    useEffect(() => {
        getAllCategories();

        if (id) {
            fetchCategory();
        }
    }, []);

    const [allCategories, setAllCategories] = useState(undefined);
    const getAllCategories = () => {
        let url = '/categories-all';
        api.get(url, {except: id ?? ''}, (res) => {
            let data = res.data.data;
            setAllCategories(data);
        }, (err) => {
            alert('error');
        });
    }

    const fetchCategory = () => {
        let url = `/categories/${id}`;
        api.get(url, {}, (res) => {
            let data = res.data.data;
            setFormData(data);
        }, (err) => {
            alert('error');
        });
    }

    // const [attributes, setAttributes] = useState([]);
    const getEmptyAttribute = () => {
        return {
            name: '',
            type: 1,
            effect_on_price: false,
            options: [],
        }
    }
    const addAttribute = () => {
        // setAttributes([...attributes, getEmptyAttribute()])
        setFormData({...formData, attributes: [...formData.attributes, getEmptyAttribute()] })
    }

    if (allCategories === undefined) return <Layout><Loader /></Layout>;

    return (
        <Layout>
            <form onSubmit={(e) => onSubmit(e)}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="font-irs-b">نام</label>
                            <input type="text" className="form-control" required
                            value={formData.name}
                               onChange={(e) =>
                                   setFormData({...formData, name: e.target.value})}/>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="font-irs-b">والد</label>
                            <select className="form-control"
                                    value={formData.parent}
                                    onChange={(e) =>
                                        setFormData({...formData, parent: e.target.value})}
                            >
                                <option value="">-</option>
                                {allCategories.map((cat) => (
                                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="font-irs-b">تصویر</label>
                            <input type="file" className="form-control"
                                   onChange={(e) =>
                                       onChangeImage(e)}
                            />
                            <img src={formData.image} style={{maxWidth: '200px'}} className="img-responsive"/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="font-irs-b">توضیحات</label>
                            <textarea className="form-control"
                                      value={formData.description}
                                      onChange={(e) =>
                                          setFormData({...formData, description: e.target.value})}
                            />
                        </div>
                    </div>
                </div>

                <hr/>
                <FontAwesomeIcon icon={faCaretLeft} />
                <strong className="font-irs-b d-inline-block pr-1">تعریف ویژگی ها</strong>

                <span className="text-success d-inline-block mr-2"
                      onClick={() => addAttribute()}
                      style={{ fontSize: '1.1rem' }}>
                    <FontAwesomeIcon icon={faPlusSquare} size={"lg"}/>
                </span>

                <Attributes formData={formData} setFormData={setFormData}/>

                <div className="row mt-5">
                    <div className="col-auto mr-auto">
                        <button className="btn btn-primary" type="submit">
                            ذخیره
                            {sending && <Spinner animation={"border"} />}
                        </button>
                    </div>
                </div>
            </form>
        </Layout>
    )
}
export default Form;
